<template>
    <div>
        <div style="padding: 0 20px">
            <div class="top">
                <div>
                    <el-input size="small" placeholder="请输入姓名/手机号搜索" v-model="queryParam"
                              style="width: 240px" suffix-icon="el-icon-search">
                    </el-input>
                    <el-button type="primary" @click="searchAgent" style="width: 96px">查询</el-button>
                </div>
                <div>
                    <el-button type="primary" @click="addAgent" style="width: 96px">新增代理商</el-button>
                </div>
            </div>
            <div>
                <el-table :data="tableData"
                          v-loading="loading"
                          :header-cell-style="{'padding-left': '3%'}"
                          :cell-style="{'padding-left': '3%'}">
                    <el-table-column prop="agentName" label="姓名"></el-table-column>
                    <el-table-column prop="mobile" label="手机号"></el-table-column>                    
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="editAgent(scope.row)">修改</el-button>
                            <el-button type="text" class="delete-button" @click="deleteAgent(scope.row)">撤销</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="pageNum"
                        :page-size="pageSize"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
        <el-dialog title="新增代理商" :visible.sync="dialogAddVisible" width="560px"
                   :close-on-click-modal="false" :before-close="cancelAdd">
            <el-form :model="agentAdd" :rules="rules" ref="add" size="small" label-width="90px">
                <el-form-item label="代理商:" prop="agentName">
                    <el-input v-model="agentAdd.agentName" style="width: 320px"></el-input>
                </el-form-item>

                <el-form-item label="手机号:" prop="mobile">
                    <el-input v-model="agentAdd.mobile" style="width: 320px"></el-input>
                </el-form-item>

                <el-form-item label="联系人:" prop="contactName">
                    <el-input v-model="agentAdd.contactName" style="width: 320px"></el-input>
                </el-form-item>

                <div class="dialog-set">
                    <el-form-item label="省市区:" prop="province">
                        <el-select v-model="agentAdd.province" placeholder="选择省"
                                   @change="chooseProvince" style="width: 140px;">
                            <el-option v-for="item in province" :key="item.provinceId"
                                       :label="item.province" :value="item.provinceId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="city" label-width="0">
                        <el-select v-model="agentAdd.city" placeholder="选择市"
                                   @change="chooseCity"  style="width: 135px">
                            <el-option v-for="item in city" :key="item.cityId"
                                       :label="item.city" :value="item.cityId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="district" label-width="0">
                        <el-select v-model="agentAdd.district" placeholder="选择区/县"
                                   style="width: 135px;">
                            <el-option v-for="item in area" :key="item.areaId"
                                       :label="item.area" :value="item.areaId"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <el-form-item label="详细地址:" prop="address">
                    <el-input v-model="agentAdd.address" style="width: 320px"></el-input>
                </el-form-item>
               
                <el-form-item label="共享药房:" prop="pharmacy">
                    <div class="tag-box" @click="openPharmacySet">
                        <el-tag
                                size="small"
                                style="margin-right: 4px"
                                v-for="item in agentAdd.pharmacy"
                                :key="item.id"
                                type="info"
                                effect="plain">
                            {{ item.name }}
                        </el-tag>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelAdd" style="width: 76px">取 消</el-button>
                <el-button type="primary" @click="confirmAdd" style="width: 76px;">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="编辑代理商" :visible.sync="dialogEditVisible" width="560px"
                   :close-on-click-modal="false" :before-close="cancelEdit">
            <el-form :model="agentEdit" :rules="rules" ref="edit" size="small" label-width="90px">
                <el-form-item label="代理商:" prop="agentName">
                    <el-input v-model="agentEdit.agentName" style="width: 320px"></el-input>
                </el-form-item>
                <el-form-item label="手机号:" prop="mobile">
                    <el-input v-model="agentEdit.mobile" style="width: 320px"></el-input>
                </el-form-item>
                <el-form-item label="联系人:" prop="contactName">
                    <el-input v-model="agentEdit.contactName" style="width: 320px"></el-input>
                </el-form-item>
                <div class="dialog-set">
                    <el-form-item label="省市区:" prop="province">
                        <el-select v-model="agentEdit.province" placeholder="选择省"
                                   @change="chooseProvince" style="width: 140px;">
                            <el-option v-for="item in province" :key="item.provinceId"
                                       :label="item.province" :value="item.provinceId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="city" label-width="0">
                        <el-select v-model="agentEdit.city" placeholder="选择市"
                                   @change="chooseCity" style="width: 135px">
                            <el-option v-for="item in city" :key="item.cityId"
                                       :label="item.city" :value="item.cityId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="district" label-width="0">
                        <el-select v-model="agentEdit.district" placeholder="选择区/县"
                                   style="width: 135px;">
                            <el-option v-for="item in area" :key="item.areaId"
                                       :label="item.area" :value="item.areaId"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <el-form-item label="详细地址:" prop="address">
                    <el-input v-model="agentEdit.address" style="width: 320px"></el-input>
                </el-form-item>
                
                <el-form-item label="药房:" prop="pharmacy">
                    <div class="tag-box" @click="openPharmacyEdit">
                        <el-tag size="small"
                                style="margin-right: 4px"
                                v-for="item in agentEdit.pharmacy"
                                :key="item.id"
                                type="info"
                                effect="plain">
                            {{ item.name }}
                        </el-tag>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelEdit" style="width: 76px">取 消</el-button>
                <el-button type="primary" @click="confirmEdit" style="width: 76px;">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="配置共享药房" :visible.sync="pharmacyVisible" width="700px" :close-on-click-modal="false">
            <div style="text-align: center">
                <el-transfer
                        v-if="items.length !== 0"
                        style="text-align: left; display: inline-block"
                        v-model="overPharmacy"
                        :props="{
                            key: 'id',
                            label: 'name',
                        }"
                        filterable
                        filter-placeholder="搜索药房名称"
                        :titles="['共享药房', '已配置共享药房']"
                        :format="{
                            noChecked: '${total}',
                            hasChecked: '${checked}/${total}'
                         }"
                        ref="addPharmacy"
                        :data="items">
                    <span slot-scope="{ option }">{{ option.name }}</span>
                </el-transfer>
            </div>
            <div slot="footer" class="dialog-footer charge">
                <el-button @click="pharmacyVisible = false" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="savePharmacy" style="width: 76px">确定</el-button>
            </div>
        </el-dialog>
           <el-dialog title="配置共享药房" :visible.sync="pharmacyEditVisible" width="700px" :close-on-click-modal="false">
            <div style="text-align: center">
                <el-transfer
                        v-if="itemsEdit.length !== 0"
                        style="text-align: left; display: inline-block"
                        v-model="overPharmacyEdit"
                        filterable
                        filter-placeholder="搜索药房名称"
                        :titles="['共享药房', '已配置共享药房']"
                        :format="{
                            noChecked: '${total}',
                            hasChecked: '${checked}/${total}'
                         }"
                        :props="{
                            key: 'id',
                            label: 'name',
                        }"
                        :data="itemsEdit">
                    <span slot-scope="{ option }">{{ option.name }}</span>
                </el-transfer>
            </div>
            <div slot="footer" class="dialog-footer charge">
                <el-button @click="pharmacyEditVisible = false" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="editPharmacy" style="width: 76px">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                authorization:localStorage.getItem('authorization'),
                queryParam: '',
                loading: true,
                tableData: [],
                // 分页信息
                pageNum: 1,
                pageSize: 10,
                total: 1,
                pages: 1,
                province: [],
                city: [],
                area: [],
                userList: [],
                dialogAddVisible: false,
                agentAdd: {
                    agentName: '',
                    mobile:'',
                    province: '',
                    city: '',
                    district: '',
                    address: '',                    
                    pharmacy: '',
                },
                rules: {
                    agentName: [{required: true, message: '请输入代理商', trigger: 'blur'}],
                    mobile: [{required: true, message: '请输入手机号', trigger: 'blur'}],
                    
                },
                pharmacyVisible: false,
                overPharmacy: [],
                items: [],
                dialogEditVisible: false,
                agentEdit: {
                    agentNo: '',
                    agentName: '',
                    mobile:'',
                    province: '',
                    city: '',
                    district: '',
                    address: '',                    
                    pharmacy: '',
                },
                pharmacyEditVisible: false,
                overPharmacyEdit: [],
                itemsEdit: [],
            };
        },
        methods: {
            // 获取代理商列表
            getData() {
                this.loading = true
                let params = {
                    queryParam: this.queryParam,
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                }
                this.axios.post('/api-b/10037/100127',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data.list.length === 0) {
                            this.$message.info('暂无数据')
                        }
                        this.tableData = res.data.data.list
                        this.total = res.data.data.total
                    } else {
                        this.$message.error(res.data.message)
                        this.tableData = []
                    }
                    this.loading = false
                }).catch(error => {
                    this.tableData = []
                    this.total = 0
                    this.loading = false
                })
            },
            // 表格换页
            handlePageChange(val) {
                this.pageNum = val;
                this.getData();
            },
            searchAgent(){
                this.getData();
            },
            // 获取省
            getProvince() {
                this.axios.get('/api-b/10028/100071',{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.province = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 取消新增
            cancelAdd() {
              this.dialogAddVisible = false
                this.$nextTick(() => {
                    this.$refs.add.resetFields()
                })
            },
            // 新增代理商弹窗按钮
            addAgent() {
                this.getProvince()
                this.dialogAddVisible = true
            },
            // 选择省
            chooseProvince(val) {
                this.axios.get('/api-b/10028/100072?father=' + val,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.city = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 选择市
            chooseCity(val) {
                this.axios.get('/api-b/10028/100073?father=' + val,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.area = res.data.data
                    }else {
                        this.$message.error(res.data.message)
                    }
                })
            },
 
            //
            openPharmacySet() {
                let params = {
                    pageNum: 1,
                    pageSize: 999
                }
                this.axios.post('/api-b/10008/100133',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data.list !== null) {
                            this.items = res.data.data.list
                            this.pharmacyVisible = true
                        } else {
                            this.$message.info('暂无数据')
                            this.items = []
                        }
                    } else {
                        this.$message.error(res.data.message)
                        this.items = []
                    }
                })
            },
            savePharmacy() {
                let pharmacys = []
                for (let i=0; i<this.overPharmacy.length; i++){
                    let pharmacy = this.items.find(item => {
                        return item.id === this.overPharmacy[i]
                    })
                    pharmacys.push(pharmacy)
                }
                this.agentAdd.pharmacy = pharmacys
                this.pharmacyVisible = false
            },
            // 确认新增代理商
            confirmAdd() {
                this.$refs.add.validate(valid => {
                    if (valid) {
                        let list = []
                        for (let i=0; i<this.agentAdd.pharmacy.length; i++) {
                            let pharmacy = {
                                pharmacyId: this.agentAdd.pharmacy[i].id,
                            }
                            list.push(pharmacy)
                        }
                        let params = {
                            agentName: this.agentAdd.agentName,
                            contactName: this.agentAdd.contactName,
                            mobile:this.agentAdd.mobile,
                            province: this.agentAdd.province,
                            city: this.agentAdd.city,
                            district: this.agentAdd.district,
                            address: this.agentAdd.address,   
                            
                            pharmacyIdList: list,
                        }
                        this.axios.post('/api-b/10037/100153',params,{
                            headers:{
                                Authorization: this.authorization
                            }
                        }).then(res => {
                            if (res.data.code === 10000) {
                                this.dialogAddVisible = false
                                this.$message.success(res.data.message)
                                this.getData()
                                this.$nextTick(() => {
                                    this.$refs.add.resetFields()
                                    this.agentAdd.pharmacy = []
                                    this.overPharmacy = []
                                    if(this.$refs.addPharmacy){
                                        this.$refs.addPharmacy.$children["0"]._data.query = '';
                                        // 清空右边搜索
                                        this.$refs.addPharmacy.$children["3"]._data.query = '';
                                    }
                                })
                            } else {
                                this.$message.error(res.data.message)
                            }
                        })
                    } else{
                        this.$message.error('请按照要求正确填写相关信息')
                    }
                })
            },
            cancelEdit() {
                this.dialogEditVisible = false
                this.$nextTick(() => {
                    this.$refs.edit.clearValidate()
                })
            },
            // 编辑代理商弹窗按钮
            editAgent(data) {
                
            this.axios.get('/api-b/10037/100170/' + data.agentNo,{
                    headers:{
                        Authorization: this.authorization,
                    }
                }).then(res => {
                    
                    if(res.data.code=== 10000) {
                        if (res.data.data !== null) {
                            this.dialogEditVisible = true
                            this.agentEdit = res.data.data
                            this.agentEdit.pharmacy = res.data.data.pharmacies
                            let list = []
                            if(this.agentEdit.pharmacy!=null){
                              for (let i=0;i<this.agentEdit.pharmacy.length;i++) {
                                if (this.agentEdit.pharmacy[i].name !== this.agentEdit.name) {
                                    list.push(this.agentEdit.pharmacy[i].id)
                                }
                            }
                            }
                         
                            this.overPharmacyEdit = list
                            if (data.address !== null) {
                                this.agentEdit.province = parseInt(this.agentEdit.province)
                                this.agentEdit.city = parseInt(this.agentEdit.city)
                                this.agentEdit.district = parseInt(this.agentEdit.district)
                                this.getProvince()
                                this.chooseProvince(this.agentEdit.province)
                                this.chooseCity(this.agentEdit.city)
                            }
                        } else {
                            this.$message.info(res.data.message)
                        }
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            openPharmacyEdit() {
                let params = {
                    pageNum: 1,
                    pageSize: 999
                }
                this.axios.post('/api-b/10008/100133',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data.list !== null) {
                            this.pharmacyEditVisible = true
                            this.itemsEdit = res.data.data.list
                        } else {
                            this.$message.info('暂无数据')
                            this.itemsEdit = []
                        }
                    } else {
                        this.$message.error(res.data.message)
                        this.itemsEdit = []
                    }
                })
            },
          
            editPharmacy() {
                let pharmacys = []
            
                
                if (this.overPharmacyEdit.length > 0) {
                    for (let i=0; i<this.overPharmacyEdit.length; i++){
                        let pharmacy = this.itemsEdit.find(item => {
                            return item.id === this.overPharmacyEdit[i]
                        })
                        pharmacys.push(pharmacy)
                    }
                }
                this.agentEdit.pharmacy = pharmacys
                this.pharmacyEditVisible = false
            },
            confirmEdit() {
                this.$refs.edit.validate(valid => {
                    if (valid) {
                        let list = []
                        for (let i=0; i<this.agentEdit.pharmacy.length; i++) {
                            let pharmacy = {
                                pharmacyId: this.agentEdit.pharmacy[i].id
                            }
                           list.push(pharmacy)
                        }
                        let params = {
                            agentNo: this.agentEdit.agentNo,
                            agentName: this.agentEdit.agentName,
                            contactName: this.agentEdit.contactName,
                            mobile:this.agentEdit.mobile,
                            province: this.agentEdit.province,
                            city: this.agentEdit.city,
                            district: this.agentEdit.district,
                            address: this.agentEdit.address,                             
                            pharmacyIdList: list,
                        }
                        this.axios.post('/api-b/10037/100169',params,{
                            headers:{
                                Authorization: this.authorization
                            }
                        }).then(res => {
                            if (res.data.code === 10000) {
                                this.dialogEditVisible = false
                                this.$message.success(res.data.message)
                                this.getData()
                                this.$nextTick(() => {
                                    this.$refs.edit.resetFields()
                                    this.agentEdit.pharmacy = []
                                    // this.overPharmacy = []
                                    // if(this.$refs.addPharmacy){
                                    //     this.$refs.addPharmacy.$children["0"]._data.query = '';
                                    //     // 清空右边搜索
                                    //     this.$refs.addPharmacy.$children["3"]._data.query = '';
                                    // }
                                })
                            } else {
                                this.$message.error(res.data.message)
                            }
                        })

                    } else{
                        this.$message.error('请按照要求正确填写相关信息')
                    }
                })
            },
            deleteAgent(data) {

                const h = this.$createElement;
                this.$msgbox({
                    message: h('div',{class:'message-box'}, [
                        h('div', { class: 'message-title-box'}, [
                            h('i', { class:'el-icon-warning message-box-icon' }, ''),
                            h('span', { class:'message-box-title'}, '确认要撤销该代理商吗？'),
                        ]),
                        h('div', null, [
                            h('span', { class:'message-box-main'}, '撤销后，该代理商将无法正常登陆。'),
                        ]),
                    ]),
                    showCancelButton: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(() => {
                    let params = new FormData()
                    params.append('agentNo',data.agentNo)
                    this.axios.post('/api-b/10037/100154',params,{
                        headers:{
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        if (res.data.code === 10000) {
                            this.$message.success(res.data.message)
                            this.getData()
                        } else {
                            this.$message.error(res.data.message)
                            this.getData()
                        }
                    }).catch(error => {})
                })
            },
           
        },
        watch: {
            hospitalName: {
                handler() {
                    this.pageNum = 1
                    this.getData()
                }
            }
        },
        created() {
            this.getData()
        }
    };
</script>

<style>

</style>
<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 12px;
        height: 52px;
    }
    .delete-button {
        margin-left: 20px;
        color: rgba(255,75,75,1) !important;
    }
    .delete-button:hover {
        color: rgba(255,75,75,0.8) !important;
    }
    .delete-button:focus {
        color: rgba(215,37,41,1) !important;
    }
    .dialog-set{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
    }
    .tag-box {
        width: 288px;
        min-height: 30px;
        border-radius: 5px;
        border: 1px solid #DCDFE6;
        padding: 0 15px
    }
</style>